import { useSelector as useReduxSelector } from 'react-redux' // eslint-disable-line no-restricted-imports

type Params<Selected = unknown> = Parameters<typeof useReduxSelector<Store, Selected>>

export function useSelector<Selected = unknown>(selector: Params<Selected>[0], equalityFn?: Params<Selected>[1]) {
  return useReduxSelector(selector, equalityFn)
}
